<script>
  import { Bar } from 'vue-chartjs'
  import {createChartData, createChartOptions} from './chartTheme'

  export default {
    extends: Bar,
    props: {
      chartData: {
        type: Object,
        default: () => ({})
      },
      options: {
        type: Object,
        default: () => ({})
      },      
    },
    mounted () {        
      this.render()
    },
    watch: {
      chartData: function() {
        this.render()
      },
      options: function() {                
        this.render()
      }
    }, 
    methods: {
      render() {
        this.renderChart(createChartData(this.chartData), createChartOptions('bar', this.options))
      }
    }
  }
</script>
